import React, { FC, useState } from 'react';
import { Button } from 'antd';
import styles from './styles.module.css';
import { diffChars } from 'diff';

type Props = {
  log: {
    descriptions: string[];
  };
};

export const TaskLogDescription: FC<Props> = ({ log }) => {
  const [show, setShow] = useState(false);
  if (!log) return null;

  const previousDescription = log.descriptions[0];
  const currentDescription = log.descriptions[1];

  if (!currentDescription || !previousDescription) return null;

  const diff = diffChars(previousDescription, currentDescription);

  return (
    <>
      <Button
        type="text"
        size="small"
        onClick={() => setShow(!show)}
        className={styles.changesButton}
      >
        {!show ? 'Show changes' : 'Hide changes'}
      </Button>
      {show && (
        <div className={styles.descriptionDiff}>
          {diff.map((part, index) => {
            let className = '';
            if (part.added) className = styles.diffAdded;
            else if (part.removed) className = styles.diffRemoved;
            return (
              <span key={index} className={className}>
                {part.value}
              </span>
            );
          })}
        </div>
      )}
    </>
  );
};
